import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionBoqImportService } from '../services/constructionBoqImport.service';
import type { ConstructionBoqItem } from '../types/construction-boq.types';
import { toast } from 'sonner';

export function useBoqImport(boqId: string) {
  const queryClient = useQueryClient();

  const importMutation = useMutation({
    mutationFn: async (items: Partial<ConstructionBoqItem>[]) => {
      // Add boq_id to all items
      const itemsWithBoqId = items.map(item => ({
        ...item,
        boq_id: boqId
      }));
      return ConstructionBoqImportService.bulkCreateBoqItems(itemsWithBoqId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'items', boqId] });
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'stats', boqId] });
      toast.success('Import hạng mục BOQ thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi import: ' + error.message);
    }
  });

  return {
    importItems: importMutation.mutateAsync,
    isImporting: importMutation.isPending
  };
}
